import React from 'react';

const Index = () => {
  return (
    <>
      <svg xmlns="http://www.w3.org/2000/svg" width="12" height="11" viewBox="0 0 12 11" fill="none">
        <path fillRule="evenodd" clipRule="evenodd" d="M10.1425 0.490662L4.5 6.57856L1.857 3.94119L0 5.89698L4.5 10.4907L12 2.44592L10.1425 0.490662Z" fill="#008060"/>
      </svg>
    </>
  );
};

export default Index;